import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@pella/sash-framework';
import { HoverEmbed } from '..';

const HoverModal = ({ defaultOpen, onClose }) => (
	<Modal
		isOpen={defaultOpen}
		onClose={onClose}
		width={1440}
		className='[&>button>span]:bg-transparent [&>button>span]:text-black'
	>
		<Modal.Header>&nbsp;</Modal.Header>
		<Modal.Content className='!p-0'>
			<HoverEmbed className='!px-0' />
		</Modal.Content>
	</Modal>
);

HoverModal.propTypes = {
	defaultOpen: PropTypes.bool,
	onClose: PropTypes.func,
};

export default HoverModal;
